import React, { useState, useEffect } from 'react';

import Typography from '@material-ui/core/Typography';
import { Card, Grid, Box, Tooltip } from '@material-ui/core';
import { AddOutlined } from '@material-ui/icons';

import ReactTimeAgo from 'react-time-ago';
// import TimeAgo from 'javascript-time-ago';
// import pt from 'javascript-time-ago/locale/pt.json';

import { generalTexts } from '../../utils/utils';
import Calendar from "../../assets/calendar.png";
import { CreateModal } from './createModal';
import { ShowModal } from './showModal';

import { useHistory } from 'react-router-dom';
import { useStyles } from './styles';
import { getAttachments } from '../../services/news';

// TimeAgo.addDefaultLocale(pt)

export default function ListNews({ news = [], addNews = false }) {
  const classes = useStyles();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openShowModal, setOpenShowModal] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [attachmentsMap, setAttachmentsMap] = useState({});
  const history = useHistory();

  useEffect(() => {
    if (!addNews && news.length > 0) {
      // Busca anexos para cada notícia (máximo 4)
      const fetchAll = async () => {
        const map = {};
        for (let i = 0; i < Math.min(news.length, 4); i++) {
          const n = news[i];
          const anexos = await getAttachments(n.ID).then(res => res.data);
          map[n.ID] = Array.isArray(anexos) ? anexos : [];
        }
        setAttachmentsMap(map);
      };
      fetchAll();
    }
  }, [addNews, news]);

  function handleClose() {
    setOpenCreateModal(false)
    setOpenShowModal(false)
    setSelectedNotice(null)
  }

  return (
    <>
      <Grid container>
        {!addNews && (
          <Typography className={classes.titleGrande} component="h2" variant="subtitle1">
            {generalTexts.newsBoard}
          </Typography>
        )}

        {news.length > 0 && (<Grid container spacing={4} alignItems="stretch" >
          {addNews && <AddNewNotice onOpen={() => history.push('/noticias/cadastro')} />}

          {news.map((notice, index) => (
            <NoticeCard
              key={index}
              notice={notice}
              onOpenModal={() => {
                if (addNews) {
                  history.push(`/noticias/${notice.ID}`)
                } else {
                  setSelectedNotice(notice);
                  setOpenShowModal(true);
                }
              }}
            />
          ))}

        </Grid>)}
      </Grid>

      <CreateModal
        notice={selectedNotice}
        open={openCreateModal}
        onClose={handleClose}
      />

      <ShowModal
        notice={selectedNotice}
        open={openShowModal}
        onClose={handleClose}
        attachments={selectedNotice ? attachmentsMap[selectedNotice.ID] || [] : []}
      />
    </>
  )
}


const baseUrl = 'https://cxd.bibi.com:3636';
function NoticeCard({ notice, onOpenModal }) {
  const { TITULO, DATA_CADASTRO } = notice
  const classes = useStyles();

  function handleClickNotice() {
    onOpenModal(notice)
  }


  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <Card className={classes.cardNotice} elevation={3} onClick={handleClickNotice}>
        <Box className={classes.bannerContainer}>
          <img className={classes.banner} src={baseUrl + notice.IMAGEM ?? "/banner.png"} alt='Banner padrão' />
        </Box>
        <Box className={classes.cardContent}>
          <Typography className={classes.title} component="h1" variant="body2">{TITULO}</Typography>

          {/* <Box
            className={classes.noticeContent}
            dangerouslySetInnerHTML={{
              __html: cleanHtmlContent(CONTEUDO)
            }}
          /> */}

          <Box>
            <Typography className={classes.positionText} component="h1" variant="subtitle2">
              <img src={Calendar} alt="Icone calendário" /> <ReactTimeAgo style={{ marginTop: '2px' }} date={new Date(DATA_CADASTRO)} /> atrás
            </Typography>
          </Box>
        </Box>
      </Card>
    </Grid>
  )
}

function AddNewNotice({ onOpen }) {
  const classes = useStyles();

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <div className={classes.moreButton} onClick={onOpen}>
        <Tooltip title="Cadastrar uma nova notícia">
          <AddOutlined style={{ fontSize: '5rem', color: '#FE5D00' }} />
        </Tooltip>
      </div>
    </Grid>
  )
}